















import { Component, Vue, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { RootState } from '@/store/types'
import { Route } from 'vue-router'
import PStorage from '@/util/PStorage'
import PCrypto from '@/util/crypto/PCrypto'
import { isElectron } from '@/util/Helpers'
import { UISize, Darkness, ThemeColour } from '@/store/ui/types'
import { encrypt, decrypt } from '@/util/crypto/EntryCrypt'

@Component
export default class App extends Vue {
    transition: string = 'fade-page-quick'
    locked: boolean = true

    @State((state: RootState) => state.ui.theme)
    accent!: ThemeColour

    @State((state: RootState) => state.ui.darkness)
    darkness!: Darkness

    @State((state: RootState) => state.ui.size)
    uiSize!: UISize

    @State((state: RootState) => state.editor.entry.icon)
    entryIcon!: string

    @State((state: RootState) => state.editor.entry.fields.title)
    entryTitle!: string

    @Watch('$route')
    onRouteChange(to: Route, from: Route): void {
        this.transition = 'fade-page-quick'
        if (to.name === 'unlock') {
            this.transition = 'swipe-down'
        } else if (from.name === 'unlock') {
            this.transition = 'swipe-up'
        }
        if (from.name === null) {
            this.transition = 'none'
        }
        if (to.name && to.name.includes('app')) {
            this.locked = false
        } else {
            this.locked = true
        }
    }

    mounted(): void {
        (window as any).notice = (opts?: Noty.Options) => this.$notice(opts);
        // debug
        (window as any).PCrypto = PCrypto;
        (window as any).EntryCrypt = { encrypt, decrypt };
        (window as any).PStorage = PStorage

        window.addEventListener('keydown', ({ key, metaKey }) => {
            if (key === 'd' && metaKey) {
                setTimeout(() => {
                    debugger
                }, 2000)
            }
            if (isElectron()) {
                if ((key === 'ArrowLeft' || key === '[') && metaKey) {
                    history.back()
                }
                if ((key === 'ArrowRight' || key === ']') && metaKey) {
                    history.forward()
                }
            }
        })
    }

    get treeOpen(): boolean {
        return this.uiSize === 'lg-desktop' && this.$route.name === 'app'
    }
}
